module.exports = __webpack_public_path__ + "static/img/mi9.374f342b.png";